import { WhiteBox, FoodsIllustrations } from "@foodpilot/foods";
import { Button, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { URLHandler } from "src/services/URLHandler";
import { UserService } from "src/services/UserService";
import { useUserNew } from "src/api/client-api/useUserNew";
import { resolveNoCompanyVariant } from "./noCompanyVariant";

export const NoCompany = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { user } = useUserNew();

    const isImpersonating = UserService.isImpersonationActive();
    const variant = resolveNoCompanyVariant(user?.hasOnlyArchivedOrganizations === true, isImpersonating);

    const content = {
        default: {
            title: t("nocompany.title"),
            infotext: t("nocompany.infotext"),
        },
        archived: {
            title: t("nocompany.archived.title", "Your company is no longer active"),
            infotext: t(
                "nocompany.archived.infotext",
                "The company your account is linked to has been deactivated. Please contact your administrator or our support team for more information.",
            ),
        },
        impersonated: {
            title: t("nocompany.impersonated.title", "No company assigned to this user"),
            infotext: t("nocompany.impersonated.infotext", "This user is not assigned to any company."),
        },
        archivedImpersonated: {
            title: t("nocompany.archived.impersonated.title", "This user's company is no longer active"),
            infotext: t(
                "nocompany.archived.impersonated.infotext",
                "The company this user is linked to has been deactivated. Deactivated companies are not accessible, even through impersonation.",
            ),
        },
    }[variant];

    return (
        <WhiteBox>
            <Stack
                flexDirection={"column"}
                padding={theme.spacing(4)}
                gap={theme.spacing(4)}
                textAlign={"center"}
                justifyContent={"center"}
                alignItems={"center"}
            >
                <Typography variant="h2">{content.title}</Typography>
                <FoodsIllustrations illustration={"contactSupport"} />
                <Typography variant="body-medium">{content.infotext}</Typography>
                <Button
                    variant="primary"
                    onClick={() => {
                        if (isImpersonating) {
                            UserService.unimpersonateUser();
                            return;
                        }

                        const url = URLHandler.login.logout();
                        navigate(url);
                    }}
                >
                    {isImpersonating ? t("auth.finish_impersonation") : t("se_deconnecter")}
                </Button>
            </Stack>
        </WhiteBox>
    );
};
